import { CustomScoringOption } from './CustomScoringOption';
import type { CustomScoringQuestionProps } from '@/utils/scoring/adapters/customScoringAdapter';

interface CustomScoringQuestionComponentProps extends CustomScoringQuestionProps {
  onMarkCorrect?: (optionId: string, isCorrect: boolean) => void;
  language?: 'en' | 'fr';
}

/**
 * CustomScoringQuestion - Manual scoring only for custom question types
 * Grid layout: 2 columns for 2-4 options, 1 column for 5+ options (matches CustomPick styling)
 */
export function CustomScoringQuestion({
  options,
  onMarkCorrect,
  language = 'en',
}: CustomScoringQuestionComponentProps) {
  const gridCols = options.length > 4 ? 'grid-cols-1' : 'grid-cols-2';

  return (
    <div className="space-y-3">
      <div className={`grid gap-4 ${gridCols}`}>
        {options.map((option, index) => (
          <CustomScoringOption
            key={option.option_id || index}
            option={option}
            language={language}
            onMarkCorrect={onMarkCorrect}
          />
        ))}
      </div>
    </div>
  );
}
